import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_drawerLayout/admin/plant/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
